import SimpleHeader from "../SimpleHeader/SimpleHeader";

const TradingStockHeader = () => <SimpleHeader title="Trending Stock" />;

export default TradingStockHeader;
